const ROUTES = {
  NOT_FOUND: "*",
  HOME: "/",
  AUTH: "/auth",
  PROFILE: '/profile',
  STATISTICS: '/statistics',
  ACTIONS: "/actions",
  PRODUCTS: "/products",
}

export default ROUTES;